import { createTheme } from "@mui/material";
import moment from "moment";

export const formatSQLDateTime = (dateTime) => {
  if (dateTime === "" || dateTime === null) return "";
  return moment(dateTime).utc().format("MM-DD-YYYY");
};

export const formatSQLDateTimeWithSlash = (dateTime) => {
  if (dateTime === "" || dateTime === null) return "";
  return moment(dateTime).utc().format("MM/DD/YY");
};

// MM/DD/YYYY
export const FormatDate = (dateString, useSlash = false) => {
  if (!dateString) return "";
  const date = new Date(dateString);

  const day = ("0" + date.getDate()).slice(-2);
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const year = date.getFullYear();
  const separator = useSlash ? "/" : "-";
  const formattedDate = `${month}${separator}${day}${separator}${year}`;

  return formattedDate;
};

export const FormatNumber = (num, roundPlace) => {
  let formattedNum = num.toFixed(3);
  formattedNum = parseFloat(formattedNum).toLocaleString();
  formattedNum = formattedNum.replace(/(\.[0-9]*[1-9])0+$/, "$1");
  return formattedNum;
};

export const downloadFile = async (row) => {
  const downloadURL = "api/Files/GetFileLink";
  fetch(downloadURL, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(row),
  })
    .then(async (response) => {
      const URL = await Promise.resolve(response.json());
      window.open(URL, "_blank").focus();
    })
    .catch((err) => console.log(err));
};

export const fetchFilterValues = async (url_path) => {
  const response = await fetch(url_path);
  const data = await response.json();
  return data;
};

export const createYearValues = (
  startYear = new Date().getFullYear(),
  howManyYearsBack = 4
) => {
  const yearValues = [];
  for (let i = 0; i <= howManyYearsBack; i++) {
    const year = startYear - i;
    yearValues.push({ id: year, label: `${year}` });
  }
  return yearValues;
};

export const validateEmail = (email) =>
  String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

export const sanitizeAlphanumeric = (value) => {
  return value.replace(/[^a-zA-Z0-9-]/g, "");
};

export const trakrefFontFamily = "Open Sans";

export const trakrefFontFamilySemiBold = "Open Sans SemiBold";

export const trakrefFontFamilyBold = "Open Sans Bold";

export const trakrefFontSFProTextSemibold = "SF Pro Text Semibold";

export const trakrefFontSFNSRegular = "SFNS Display Regular";


export const postRequestHeaders = {
  "Accept": "application/json",
  "Content-Type": "application/json",
};

export const countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bonaire, Sint Eustatius and Saba",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory ",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cayman Islands ",
  "Central African Republic ",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos",
  "Colombia",
  "Comoros ",
  "Congo",
  "Congo ",
  "Cook Islands",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Curaçao",
  "Cyprus",
  "Czechia",
  "Côte d'Ivoire",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Falkland Islands [Malvinas]",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island and McDonald Islands",
  "Holy See",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "North Korea",
  "South Korea",
  "Kuwait",
  "Kyrgyzstan",
  "Lao People's Democratic Republic",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine, State of",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Republic of North Macedonia",
  "Romania",
  "Russian Federation",
  "Rwanda",
  "Réunion",
  "Saint Barthélemy",
  "Saint Helena, Ascension and Tristan da Cunha",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and the South Sandwich Islands",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United States of America",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Viet Nam",
  "Virgin Islands",
  "Virgin Islands",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
  "Åland Islands",
];

export const states = [
  { name: "Alabama", value: "alabama", code: "AL" },
  { name: "Alaska", value: "alaska", code: "AK" },
  { name: "Arizona", value: "arizona", code: "AZ" },
  { name: "Arkansas", value: "arkansas", code: "AR" },
  { name: "California", value: "california", code: "CA" },
  { name: "Colorado", value: "colorado", code: "CO" },
  { name: "Connecticut", value: "connecticut", code: "CT" },
  { name: "Delaware", value: "delaware", code: "DE" },
  { name: "Florida", value: "florida", code: "FL" },
  { name: "Georgia", value: "georgia", code: "GA" },
  { name: "Hawaii", value: "hawaii", code: "HI" },
  { name: "Idaho", value: "idaho", code: "ID" },
  { name: "Illinois", value: "illinois", code: "IL" },
  { name: "Indiana", value: "indiana", code: "IN" },
  { name: "Iowa", value: "iowa", code: "IA" },
  { name: "Kansas", value: "kansas", code: "KS" },
  { name: "Kentucky", value: "kentucky", code: "KY" },
  { name: "Louisiana", value: "louisiana", code: "LA" },
  { name: "Maine", value: "maine", code: "ME" },
  { name: "Maryland", value: "maryland", code: "MD" },
  { name: "Massachusetts", value: "massachusetts", code: "MA" },
  { name: "Michigan", value: "michigan", code: "MI" },
  { name: "Minnesota", value: "minnesota", code: "MN" },
  { name: "Mississippi", value: "mississippi", code: "MS" },
  { name: "Missouri", value: "missouri", code: "MO" },
  { name: "Montana", value: "montana", code: "MT" },
  { name: "Nebraska", value: "nebraska", code: "NE" },
  { name: "Nevada", value: "nevada", code: "NV" },
  { name: "New Hampshire", value: "newHampshire", code: "NH" },
  { name: "New Jersey", value: "newJersey", code: "NJ" },
  { name: "New Mexico", value: "newMexico", code: "NM" },
  { name: "New York", value: "newYork", code: "NY" },
  { name: "North Carolina", value: "northCarolina", code: "NC" },
  { name: "North Dakota", value: "northDakota", code: "ND" },
  { name: "Ohio", value: "ohio", code: "OH" },
  { name: "Oklahoma", value: "oklahoma", code: "OK" },
  { name: "Oregon", value: "oregon", code: "OR" },
  { name: "Pennsylvania", value: "pennsylvania", code: "PA" },
  { name: "Rhode Island", value: "rhodeIsland", code: "RI" },
  { name: "South Carolina", value: "southCarolina", code: "SC" },
  { name: "South Dakota", value: "southDakota", code: "SD" },
  { name: "Tennessee", value: "tennessee", code: "TN" },
  { name: "Texas", value: "texas", code: "TX" },
  { name: "Utah", value: "utah", code: "UT" },
  { name: "Vermont", value: "vermont", code: "VT" },
  { name: "Virginia", value: "virginia", code: "VA" },
  { name: "Washington", value: "washington", code: "WA" },
  { name: "West Virginia", value: "westVirginia", code: "WV" },
  { name: "Wyoming", value: "Wyoming", code: "WY" },
];

export const addLocationCountries = [
  { name: "United States", value: "UnitedStates", code: "US" },
  { name: "Belgium", value: "Belgium", code: "BE"  },
  { name: "Canada", value: "Canada", code: "CA"  },
  { name: "France", value: "France", code: "FR"  },
  { name: "United Kingdom", value: "UnitedKingdom", code: "GB"  },
  { name: "United Arab Emirates", value: "UnitedArabEmirates", code: "UAE"  },
];

//To map country and state values that do not align with the database.
export const filterCountries = ["US","CA"];

export const belgiumStates = [
  { name: "Brussels-Capital Region", value: "brusselsCapitalRegion" },
  { name: "Flemish Region", value: "flemishRegion" },
  { name: "Walloon Region", value: "walloonRegion" },
];

export const canadaStates = [
  { name: "Alberta", value: "alberta", code: "AB" },
  { name: "British Columbia", value: "britishColumbia", code: "BC" },
  { name: "Manitoba", value: "manitoba", code: "MB" },
  { name: "New Brunswick", value: "newBrunswick", code: "NB" },
  { name: "Newfoundland and Labrador", value: "newfoundlandAndLabrador", code: "NL" },
  { name: "Northwest Territories", value: "northwestTerritories", code: "NT" },
  { name: "Nova Scotia", value: "novaScotia", code: "NS" },
  { name: "Nunavut", value: "nunavut", code: "NU" },
  { name: "Ontario", value: "ontario", code: "ON" },
  { name: "Prince Edward Island", value: "princeEdwardIsland", code: "PE" },
  { name: "Quebec", value: "quebec", code: "QC" },
  { name: "Saskatchewan", value: "saskatchewan", code: "SK" },
  { name: "Yukon", value: "yukon", code: "YT" },
];

export const frenchStates = [
  { name: "Auvergne-Rhône-Alpes", value: "auvergneRhoneAlpes" },
  { name: "Bourgogne-Franche-Comté", value: "bourgogneFrancheComte" },
  { name: "Brittany", value: "brittany" },
  { name: "Centre-Val de Loire", value: "centreValDeLoire" },
  { name: "Corsica", value: "corsica" },
  { name: "Grand Est", value: "grandEst" },
  { name: "Hauts-de-France", value: "hautsDeFrance" },
  { name: "Île-de-France", value: "ileDeFrance" },
  { name: "Normandy", value: "normandy" },
  { name: "Nouvelle-Aquitaine", value: "nouvelleAquitaine" },
  { name: "Occitanie", value: "occitanie" },
  { name: "Pays de la Loire", value: "paysDeLaLoire" },
  { name: "Provence-Alpes-Côte d'Azur", value: "provenceAlpesCoteDAzur" },
  { name: "French Guiana", value: "frenchGuiana" },
  { name: "Guadeloupe", value: "guadeloupe" },
  { name: "Martinique", value: "martinique" },
  { name: "Mayotte", value: "mayotte" },
  { name: "Réunion", value: "reunion" },
];

export const ukStates = [
  { name: "England", value: "england" },
  { name: "Northern Ireland", value: "northernIreland" },
  { name: "Scotland", value: "scotland" },
  { name: "Wales", value: "wales" },
];

export const uaeEmirates = [
  { name: "Abu Dhabi", value: "abuDhabi" },
  { name: "Ajman", value: "ajman" },
  { name: "Dubai", value: "dubai" },
  { name: "Fujairah", value: "fujairah" },
  { name: "Ras Al Khaimah", value: "rasAlKhaimah" },
  { name: "Sharjah", value: "sharjah" },
  { name: "Umm Al Quwain", value: "ummAlQuwain" },
];

export const stateCode = [
  ...canadaStates,
  ...states,
];

export const AppLanguage = [
  {
    id: "en-US",
    name: "English",
  },
  {
    id: "es-ES",
    name: "Spanish",
  },
  {
    id: "fr-FR",
    name: "French",
  }
];

export const AppRoles = {
  System_Administrator: 'System Administrator',
  Manage_Users: 'Manage Users',
  Manage_Locations: 'Manage Locations',
  Manage_Inventory: 'Manage Inventory',
  Add_Service_Event: 'Add Service Event',
  Input_Service_Event_Data: 'Input Service Event Data',
  Reopen_Closed_Service_Event: 'Re-open Closed Service Event',
  View_Locations: 'View Locations',
  View_Reports: 'View Reports',
  View_Users: 'View Users',
  View_Beta_Dashboard: 'View Compliance Center',
  Manage_Inventory_OrAdmin: 'Asset Manager',
  Add_Service_Event_OrAdmin: 'Service Event Manager',
  Transfer_Gas_CurrentInstance: 'Gas Transfer Manager',
  Tenant_Asset_Manager: 'Tenant Asset Manager',
  ContractorLite_Asset_Manager: 'ContractorLite Asset Manager',
  SF6_Asset_Manager: 'SF6 Asset Manager',
  Compliance_Report_Viewer: 'Report Viewer',
  Tenant_Administrator_CurrentInstance: 'Instance Tenant Administrator',
  View_Users_CurrentInstance: 'Instance User Manager',
  Instance_New_Data_Model: 'Instance New Data Model',
  Instance_Legacy_Data_Model: 'Instance Legacy Data Model',
  Instance_Uses_Meters: 'Instance Uses Meters',
  Instance_AdHocReports: 'Instance Ad-Hoc Reports',
  InstanceType_Tenant: 'Instance Type Tenant',
  InstanceType_ContractorLite: 'Instance Type ContractorLite',
  InstanceType_SF6: 'Instance Type SF6',
  Can_Manage_User: 'Can Manage User'
};

export const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);

export const capitalizeFirstLetterInString = string => string.trim().split(" ").map(x => x.charAt(0).toUpperCase() + x.slice(1)).join(" ");

export const dateTimeAgo = (date) => {
  const milliseconds = 1000;

  var seconds = Math.floor((new Date() - date) / milliseconds);

  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) === 1 ? "1 year ago" : Math.floor(interval) + "years ago";
  }

  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) === 1 ? "1 month ago" : Math.floor(interval) + "months ago";
  }

  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) === 1 ? "yesterday" : Math.floor(interval) + "days ago";
  }

  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + "h ago"; // 1 hour = 3600 seconds
  }

  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + "m ago"; // 1 minute = 60 seconds
  }

  return "just now";
};




// PWA Breakpoints - Feature 14077
// Desktop breakpoint lowered from 1280px to 800px (US 14628) so desktop users
// retain the full desktop UI when working in resized / side-by-side windows.
export const isMobile = globalThis.innerWidth <= 767;

export const isDesktop = globalThis.innerWidth >= 800;

export const isBarcodeScanSupported = () =>
    typeof navigator !== 'undefined' &&
    !!navigator.mediaDevices &&
    typeof navigator.mediaDevices.getUserMedia === 'function';

export const getBrowser = () => {
    if (
        window.navigator
        && window.navigator.userAgentData
        && !!window.navigator.userAgentData.brands.length
    ) {
        return `${window.navigator.userAgentData.brands[0].brand} ${window.navigator.userAgentData.brands[0].version}`.trim();
    }

    return 'Could not detect browser';
};

// duplicate `sm` and `md` because our project uses both breakpoints to represent tablet size.
export const customTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,        // Mobile: 0-767px
      sm: 768,      // Tablet start: 768px
      md: 768,      // Tablet start: 768px
      lg: 800,      // Desktop start: 800px
    },
  },
});

export const defaultToastOptions = { duration: 5000 }; // in ms

export const formatDateWithZ = (dateString) => {
  if (!dateString) {
    return '';
  }

  const ensuredUtcString = dateString.endsWith('Z')
    ? dateString
    : dateString + 'Z';

  return moment(ensuredUtcString).utc().format('MM/DD/YYYY');
};
